export type Tool = {
  name: string;
  image: string;
};

export type ToolArray = Array<Tool>;

const TOOLS: ToolArray = [
  {
    name: 'React.js',
    image:
      'https://res.cloudinary.com/trycatch/image/upload/v1626616797/thexdev/tools/ui_logo_react_js_mpbph3.svg',
  },
  {
    name: 'Next.js',
    image:
      'https://res.cloudinary.com/trycatch/image/upload/v1626616797/thexdev/tools/ui_logo_next_js_olptzu.svg',
  },
  {
    name: 'Laravel',
    image:
      'https://res.cloudinary.com/trycatch/image/upload/v1626616798/thexdev/tools/ui_logo_laravel_pie6fr.svg',
  },
  {
    name: 'NGINX',
    image:
      'https://res.cloudinary.com/trycatch/image/upload/v1626616797/thexdev/tools/ui_logo_nginx_b2hvvz.svg',
  },
  {
    name: 'Figma',
    image:
      'https://res.cloudinary.com/trycatch/image/upload/v1626616797/thexdev/tools/ui_logo_figma_jxyv48.svg',
  },
  {
    name: 'TailwindCSS',
    image:
      'https://res.cloudinary.com/trycatch/image/upload/v1626616797/thexdev/tools/ui_logo_tailwind_css_v2nqmm.svg',
  },
  {
    name: 'Git',
    image:
      'https://res.cloudinary.com/trycatch/image/upload/v1626616797/thexdev/tools/ui_logo_git_glwfek.svg',
  },
];

export default TOOLS;
